import React from 'react';

interface WaveformProps {
  color?: string;
  barCount?: number;
  height?: number;
}

export function Waveform({ color = 'currentColor', barCount = 4, height = 16 }: WaveformProps) {
  return (
    <div className="flex items-end gap-[2px]" style={{ height }}>
      {Array.from({ length: barCount }, (_, i) => (
        <div
          key={i}
          className="waveform-bar"
          style={{
            background: color,
            height: '100%',
            animationDelay: `${i * 0.15}s`,
          }}
        />
      ))}
    </div>
  );
}
